import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EnvChecker from "./components/EnvChecker";
import { CurrencyProvider } from "./hooks/useUserCurrency";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Subscription from "./pages/Subscription";
import Intelligence from "./pages/Intelligence";
import Landing from "./pages/Landing";
import NotFound from "./pages/NotFound";
import Calendario from "./pages/Calendario";
import TodoPage from "./pages/Todo";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <EnvChecker>
      <CurrencyProvider>
        <TooltipProvider delayDuration={0}>
          <Sonner position="top-right" richColors closeButton />
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/lp" element={<Landing />} />
            <Route path="/vendas" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/central-inteligente" element={<Intelligence />} />
            <Route path="/clientes" element={<Index />} />
            <Route path="/vencimentos" element={<Index />} />
            <Route path="/relatorios" element={<Dashboard />} />
            <Route path="/configuracoes" element={<Subscription />} />
            <Route path="/calendario" element={<Calendario />} />
            <Route path="/todo" element={<TodoPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </CurrencyProvider>
    </EnvChecker>
  </QueryClientProvider>
);

export default App;
